




















































import Component from 'vue-class-component'
import { Prop, Vue } from 'vue-property-decorator'
import { Routes } from '@/router/routes'
import PriceConfig from '@/dto/price_config/PriceConfig'
import priceConfigStore from '@/stores/PriceConfigStore'

@Component
export default class PopupMenu extends Vue {
  @Prop(Object)
  model: PriceConfig

  isShowConfirmDialog: boolean = false
  isShowMenu: boolean = false
  priceConfigStore = priceConfigStore

  async removePriceConfig() {
    const priceConfigId = this.model.id as number

    if (this.$route.params.priceConfigId === priceConfigId.toString()) {
      await this.$router.push({
        name: Routes.priceConfigs,
      })
    }

    this.priceConfigStore.deletePriceConfig(priceConfigId)
  }

  toggleEnabled() {
    const model = Object.assign({}, this.model)
    model.enabled = !model.enabled

    this.priceConfigStore.savePriceConfig(model)
  }

  get enabledBtnLabel() {
    return this.model.enabled ? 'Отключить' : 'Включить'
  }
}
